<template>
  <div
    v-if="destination.longitude && destination.latitude"
    class="map-modal size-full my-4 md:my-5"
  >
    <div class="map overflow-clip">
      <LazyMapbox
        id="map"
        ref="map"
        class="relative"
        :center="[destination.longitude, destination.latitude]"
        :zoom="9"
        :size-to-parent-bounds="true"
      >
        <MapboxMarker
          v-for="(item, index) in mapItemsList"
          :key="index"
          :offset="-3"
          :coordinates="[item.longitude, item.latitude]"
          @mouseover="highlightedOpen(item)"
          @touchstart="highlightedOpen(item)"
        />
        <MapboxNavigationControl />
      </LazyMapbox>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  destination: {
    type: Object,
    default: () => ({}),
  },
  filledSection: {
    type: Object,
    default: () => ({}),
  },
})

const map = ref(null)
const imgUrl = 'https://res.cloudinary.com/rolfs-flyg-buss/image/upload/f_auto,q_auto,h_500,w_500,g_auto,c_fill,dpr_1.0/'

const shortenText = (text) => {
  if (text.length > 20) {
    return text.substring(0, 20) + '...'
  }
  return text
}

const mapItemsList = computed(() => {
  const sectionData = props.filledSection
  if (sectionData && sectionData.list) {
    return sectionData.list.map(item => ({
      longitude: item.longitude,
      latitude: item.latitude,
      cloudinary_image: item.cloudinary_image,
      name: item.name,
      location: item.location,
      description: item.description,
    }))
  }
  return []
})

const highlightedOpen = (item) => {
  if (!map.value) {
    return
  }

  if (map.value.popup) {
    map.value.popup.remove()
  }

  const popupContent = generatePopupContent(item)
  const popup = map.value.showPopup([item.longitude, item.latitude], popupContent, { offset: [-2, -20] })
  map.value.popup = popup
}

const generatePopupContent = (item) => {
  return `<div class="popup-content">
            ${item.cloudinary_image ? `<img class="small-image" src="${imgUrl}${item.cloudinary_image}" alt="${item.name}" />` : ''}
            <div class="popup-text">
              <h5>${item.name}</h5>
              ${item.location ? `<p>${shortenText(item.location)}</p>` : ''}
              ${item.description ? `<p>${shortenText(item.description)}</p>` : ''}
            </div>
          </div>`
}

defineExpose({ highlightedOpen })
</script>

<style lang="scss" scoped>
/*! purgecss start ignore */
  :deep(.mapboxgl-popup-content) {
    padding: 0;
  }
  :deep(.small-image) {
    width: 185px;
    height: 80px;
    object-fit: cover;
    object-position: center;
  }
  :deep(.popup-text) {
    padding: 10px 10px 15px;
    h5 {
      margin: 0;
      margin-bottom: 5px;
    }
    p {
      margin: 0;
      line-height: 17px;
    }
  }

/*! purgecss end ignore */
</style>